import React, { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { Box, TextField, Autocomplete } from "@mui/material";
import { IHouse } from "pages/OrderModal/components/SearchAddressInput/types";
import { ISearchBuildingInputProps } from "./types";
import styles from "pages/OrderModal/components/SearchAddressInput/SearchAddressInput.styled";

const SearchBuildingInput: React.FC<ISearchBuildingInputProps> = ({
  data,
  initialValue,
  onSearch,
  onSelectValue,
  sx,
  label,
  disabled,
  name,
}) => {
  const [inputValue, setInputValue] = useState(initialValue || "");
  const [selectedValue, setSelectedValue] = useState<IHouse | null>(null);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
    } else {
      setInputValue("");
    }
  }, [initialValue]);

  useEffect(() => {
    onSelectValue(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    if (disabled) {
      setInputValue("");
      setSelectedValue(null);
    }
  }, [disabled]);

  const searchStyles = {
    ...styles.autocompleteInput,
    ...sx,
  };

  const handleSelectChange = useCallback(
    (event: SyntheticEvent, value: IHouse | null): void => {
      setSelectedValue(value);
      value && setInputValue(value.house);
    },
    [name],
  );

  const handleInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onSearch && onSearch(newValue);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Autocomplete
      sx={searchStyles}
      options={data}
      getOptionLabel={(option) => option.house}
      inputValue={inputValue}
      value={selectedValue}
      onChange={handleSelectChange}
      clearIcon={null}
      disabled={disabled}
      open={isFocused && !!data.length && !selectedValue}
      onFocus={handleFocus}
      onBlur={handleBlur}
      renderInput={(params) => (
        <TextField {...params} label={label} onChange={handleInputChanged} />
      )}
      renderOption={(props, option) => {
        return (
          <Box {...props} component="li" sx={styles.option} key={option.lat}>
            {option.house}
          </Box>
        );
      }}
    />
  );
};

export default SearchBuildingInput;
